import turboMount, { registerComponent } from '@/global/turbo-mount';
import JobListings from '@/components/react/job-listings/JobListings';

registerComponent(turboMount, 'JobListings', JobListings);
